import $ from 'jquery';
import 'parsleyjs';
import './Language/parsley';
import 'emailDecrypt';
//import 'bootstrap';

import './General/Setup';
import './General/Accessibility';
import './General/EntropyCheck';
import './General/Lightbox';
import './General/Select';
import './General/Menu';
import './General/BackToTop';
import './General/Datepicker';
import './General/Footnotes';
import './General/SmoothScroll';
import './General/TwoClick';
import './General/Lehrplan';
import './General/Slider';
import './General/SearchPopup';
import './General/Newsletter';
import './General/Register';
import './General/ShowPassword';
import './General/RegisterUsername';
import './General/ArchiveDisclaimer';
import './General/Modal';
// import './General/LangMenu';

// import './Mask/Gallery';
import './Mask/Youtube';
// import './Mask/Maps';
import './Mask/Accordion';

import './Extensions/News/Slider';
import './Extensions/Publications';
import './Extensions/EkArchive';
import './Extensions/KeSearch';
import './Extensions/Lfmpublications';

var isDev = process.env.NODE_ENV !== 'production';

if (isDev) {
    console.log('%cTheme.js successfully initialized with webpack! 🌊☀', "color: green");
}

// just a simple resize trigger. Nice to have.
$(window).trigger('resize');
